<template>
  <vs-row class="p-3 mt-2 shadow-sm bg-white">
    <vs-col vs-lg="4">
      <vs-row>
        <vs-col vs-lg="12" class="text-truncate">
          <vs-chip @click.native="copyEmailToClipboard(item.id)">
            <vs-avatar
              :icon="'send'"
              :color="'gray'"
            />
            {{ item.id }}
          </vs-chip>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-lg="12">
          <vs-chip @click.native="copyEmailToClipboard(localTimestamp)">
            <vs-avatar
              :icon="'event'"
              :color="'gray'"
            />
            {{ localTimestamp | dateFormatDateTime }}
          </vs-chip>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-lg="7">
      {{ item.message }}
    </vs-col>
    <vs-col vs-lg="1" vs-type="flex" vs-justify="center" vs-align="center">
      <Options
        :item="item"
        v-on:deleted="handleDeleted"
      />
    </vs-col>
  </vs-row>
</template>
<script>

import Options from './Options';

export default {
  name: 'ListRow',
  components: {
    Options
  },
  data() {
    return {};
  },
  computed: {
    localTimestamp() {
      return new Date(this.item.timestamp);
    },
    showOptions() {
      return this.item.message && this.item.message.indexOf('Amazon SES has suppressed sending to this address because it has a recent history of bouncing as an invalid address.') >= 0;
    }
  },
  watch: {},
  methods: {
    handleDeleted(...args) {
      this.$emit('deleted', { ...args });
    },
    copyEmailToClipboard(...args) {
      const text = args.join(' ');
      navigator.clipboard.writeText(text);
      this.$bvToast.toast(
        `Se ha copiado: ${text}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true
        }
      );
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style scoped>
.loadData {
  height: 80vh;
}
</style>
